<!--实时业绩查询-->
<template>
  <div class="RealtimePerformanceQuery">
    <app-breadcrumb />
    <div class="page-container">
      <el-table v-loading="loading" :data="list" style="width: 100%" size="mini" border fit stripe>
        <!--部门-->
        <el-table-column :label="$t('title.department')" prop="memberNo" align="center" />
        <!--结算完结期次-->
        <el-table-column :label="$t('closing.period')" prop="wWeek" align="center" />
        <!--已结算业绩-->
        <el-table-column :label="$t('settlement.performance')" prop="calcTotalsell" align="center" />
        <!--保留业绩-->
        <el-table-column :label="$t('point.lastPoint')" prop="lastPoint" align="center" />
        <!--未结算业绩-->
        <el-table-column :label="$t('unsettled.performance')" prop="sell" align="center" />
        <!--累计业绩-->
        <el-table-column :label="$t('bd.accuPoint')" prop="allSell" align="center" />
      </el-table>
      <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
  import {bdBonusRealTimes} from "@/api/ay-personal-center/personalcenter"

export default {
  name: 'RealtimePerformanceQuery',
  components: { Pagination },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      bdBonusRealTimes({...this.listQuery}).then(res => {
        this.list = res.data.records
        this.total = +res.data.total
        this.loading = false
      }).catch(() => {
          this.$message.error(this.$t('Query_failed')) // 查询失败
          this.loading = false
      })
    }
  }
}
</script>

<style>

</style>
